import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { AssetModuleBundleSchema } from "../../_offline/models/asset-module-bundle.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class AssetModuleBundleDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  get(): Observable<AssetModuleBundleSchema | null> {
    return this.ipcSendSync(IPC_CHANNEL.ASSET_MODULE_BUNDLE.GET);
  }

  put(schema: AssetModuleBundleSchema): Observable<AssetModuleBundleSchema> {
    return this.ipcSendSync(IPC_CHANNEL.ASSET_MODULE_BUNDLE.PUT, schema);
  }

  delete(): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.ASSET_MODULE_BUNDLE.DELETE);
  }
}
